import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.specialization.distribution');
import { OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { RegionSelectionService } from 'src/app/region-selection.service';

@Component({
    selector: 'wiz-page-specialization-distribution',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.specialization.distribution/view.scss */
:host {
  display: block;
  min-height: 100%;
  background: #f4f6f8;
}

.specialization-page-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
  border-bottom: 1px solid #cbd5e1;
  padding: 18px 0 20px;
}

.specialization-page-heading__eyebrow {
  color: #285b8c;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.specialization-page-heading h1 {
  margin-top: 5px;
  color: #172231;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.25;
}

.specialization-page-heading p:last-child {
  margin-top: 5px;
  color: #64748b;
  font-size: 12px;
}

.specialization-page-heading__badge {
  flex: 0 0 auto;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  background: #fff;
  padding: 6px 12px;
  color: #285b8c;
  font-size: 10px;
  font-weight: 800;
}

@media (max-width: 640px) {
  .specialization-page-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
    padding-top: 10px;
  }
  .specialization-page-heading h1 {
    font-size: 23px;
  }
}`],
})
export class PageSpecializationDistributionComponent implements OnInit, OnDestroy {
    public selectedRegionKey: string = 'daejeon';
    private selectionSubscription: Subscription | null = null;

    constructor(@Inject( RegionSelectionService) public regionSelection: RegionSelectionService) { }

    public async ngOnInit() {
        await this.regionSelection.loadTree();
        this.syncSelection();
        this.selectionSubscription = this.regionSelection.selection$.subscribe(() => {
            this.syncSelection();
        });
    }

    public ngOnDestroy() {
        this.selectionSubscription?.unsubscribe();
    }

    public onRegionRequested(regionRef: string) {
        this.regionSelection.selectByRef(regionRef);
        this.syncSelection();
    }

    private syncSelection() {
        this.selectedRegionKey = this.regionSelection.selection?.analysis_key || 'daejeon';
    }
}

export default PageSpecializationDistributionComponent;